import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 1360px;
  margin: 0 auto;
`;

export const FilterContainer = styled.div`
  padding: 64px 0 0 32px;
  width: calc(100% - 35px);
  margin-left: -12px;
  p {
    width: 180px;
  }

  ${breakpoints.md} {
    width: 700px;
  }

  ${breakpoints.lg} {
    margin-left: 0;
  }
`;

export const SearchResultsContainer = styled.div`
  flex: 1;
  overflow: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
`;
